"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationHeadsUpWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var CancellationHeadsUpWidget = /** @class */ (function (_super) {
    __extends(CancellationHeadsUpWidget, _super);
    function CancellationHeadsUpWidget(props) {
        return _super.call(this, props) || this;
    }
    CancellationHeadsUpWidget.prototype.render = function () {
        var interaction = this.props.interaction;
        if (interaction.uistate.productsForCancellation && interaction.uistate.productsForCancellation.includes(services_1.PRODUCT_MOTOR)) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "panel narrow mb-4 banner banner-info" },
                    React.createElement("p", null,
                        "Heads up - ",
                        React.createElement("span", { className: "font-weight-bold" }, "if you cancel your Flow subscription, you\u2019ll no longer be covered"),
                        ". Here\u2019s the small print - you have a legal obligation to make sure you\u2019re insured to drive at all times if you use a car in the UK, so you\u2019ll need to arrange alternative cover for your car(s). The good news, you can always come back at any time."))));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "panel narrow mb-4 banner banner-info" },
                    React.createElement("p", null,
                        "Heads up - ",
                        React.createElement("span", { className: "font-weight-bold" }, "if you cancel your Flow subscription, you\u2019ll no longer be covered"),
                        ". The good news, you can always come back at any time."))));
        }
    };
    return CancellationHeadsUpWidget;
}(plugin_journey_1.WidgetBase));
exports.CancellationHeadsUpWidget = CancellationHeadsUpWidget;
//# sourceMappingURL=CancellationHeadsUpWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CancellationHeadsUpWidget.js
// module id = 3495
// module chunks = 0